import { AccountService } from 'src/app/service/AccountService';
import { isNullOrUndefined } from 'util';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { UserService } from 'src/app/service/user.service';
import { MasterConfigrationService } from 'src/app/service/MasterConfigrationService';
import { CommonService } from 'src/app/service/CommonService';
import { AlertsService } from 'angular-alert-module';
import { PagerService } from 'src/app/service/pager-service.service';
import { Trpconsignment } from 'src/app/Model/Trpconsignment';
import { GRbookingervice } from 'src/app/service/GRbookingservice';
import { Router, ActivatedRoute } from '@angular/router';
import { PartyMaster } from 'src/app/Model/PartyMaster';
import { Applicationcl } from 'src/app/Model/Applicationcl';
import { GRBooking } from 'src/app/Model/GRBooking';
import { UserMaster } from 'src/app/Model/UserMaster';
import { AutoLogoutService } from 'src/app/service/auto-logout.service';
import { VehicleChalanService } from 'src/app/service/VehicleChalanService';
import { TrpmstbillDetail } from 'src/app/Model/TrpmstbillDetail';
import { Trpmstbill } from 'src/app/Model/Trpmstbill';
import { environment } from 'src/environments/environment';
import { Gpsdata } from 'src/app/Model/Gpsdata';
import { ServiceStatus } from 'src/app/Model/ServiceStatus';
import { ResponseCode } from 'src/app/CheckResponse';

@Component({
  selector: 'app-trackandtrace',
  templateUrl: './trackandtrace.component.html',
  styleUrls: [ './trackandtrace.component.css' ]
})
export class TrackandtraceComponent implements OnInit {
  public GRControl = new FormControl();
  public GROptions: string[] = [];
  public InvoiceList: any[] = [];
  public ChallanList: any[];
  public GrUpdateHistory: any[];
  public MRDetail: any[];
  public GRfilteredOptions: Observable<string[]>;
  public GRControl2 = new FormControl();
  public ManualRefNofilteredOptions: Observable<string[]>;
  public MGROptions: string[] = [];
  public ConsignerName: string;
  public ConsigeeName: string;
  public FromLOC: string;
  public TOLOC: string;
  public FreightMode: string;
  public userId: number;
  public Grno: string;

  constructor (
    private _service: UserService, private oMasterConfigrationService: MasterConfigrationService, public commonservice: CommonService,
    private alerts: AlertsService, private AutoLogoutService: AutoLogoutService, private oAccountService: AccountService,
    private pagerService: PagerService, public oTrpconsignment: Trpconsignment, public oGRbookingervice: GRbookingervice, private router: Router,
    private ActivatedRoute: ActivatedRoute, public ModelPartyMaster: PartyMaster, public oApplicationcl: Applicationcl,
    public oGRBooking: GRBooking, public oUserMaster: UserMaster, public oVchalanervice: VehicleChalanService, public oTrpmstbillDetail: TrpmstbillDetail,
    public oTrpmstbill: Trpmstbill, public oGpsdata: Gpsdata) {
    this.AutoLogoutService.CheckAuthentication();
    this.userId = parseInt(sessionStorage.getItem("userid"));
    this.GetGRList();
  }

  ngOnInit() {
    // this.GRfilteredOptions = this.GRControl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filter(value))
    //   );

    // this.ManualRefNofilteredOptions = this.GRControl2.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filterManualGR(value))
    //   );

  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.GROptions.filter(option => option.toLowerCase().includes(filterValue));
    //return this.partylist.filter(option => option.ACC_NAME.toLowerCase().includes(filterValue));
  }

  private _filterManualGR(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.MGROptions.filter(option => option.toLowerCase().includes(filterValue));
  }

  public NavigatetoGPS(item: any) {
    window.open(environment.MvcWebUrl + "GPSLocation.aspx?Name=" + item.VehicleNo + "&Latitude=" + item.Latitude + "&Longitude=" + item.Longitude + "&Description=" + item.Place);
  }

  public SearchDetail() {
    if (isNullOrUndefined(this.Grno)) {
      alert("Please enter GR or Ref No");
    }
    else {
      this.GETGRDetail(this.Grno, "");
    }
  }

  GetGRList() {
    // this.oApplicationcl.IsProgressBarEnable = true;
    // this.oGRbookingervice.GETGRNOLIST(1).subscribe(
    //   data => {
    //     this.GROptions = data;
    //     this.GRControl.setValue('a');
    //     this.GRControl.setValue('');
    //     this.oApplicationcl.IsProgressBarEnable = false;
    //   });
    // this.oGRbookingervice.GETGRNOLIST(3).subscribe(
    //   data => {
    //     this.MGROptions = data;
    //     this.GRControl2.setValue('a');
    //     this.GRControl2.setValue('');
    //     this.oApplicationcl.IsProgressBarEnable = false;
    //   });
  }

  ManualRefNoSelected(input: any) {
    this.GETGRDetail('', input);
  }

  GRNoSelected(input: any) {
    this.GETGRDetail(input, '');
  }

  GETGRDetail(cnid: string, refid: string) {
    this.oApplicationcl.IsProgressBarEnable = true;
    this.oGRbookingervice.GETGRDetailByCnoOrRefNo(cnid, refid).subscribe(
      data => {
        this.oTrpconsignment = data;
        if (isNullOrUndefined(this.oTrpconsignment.CN_NO)) {
          this.oApplicationcl.IsProgressBarEnable = false;
          alert("Record not found.")
          return;
        }
        this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_CRCODE).subscribe(
          data1 => {
            this.ConsignerName = data1.ACC_NAME;
          });
        this.oMasterConfigrationService.GetSinglePartyRecord(this.oTrpconsignment.CN_CNCODE).subscribe(
          data2 => {
            this.ConsigeeName = data2.ACC_NAME;
          });
        this.oMasterConfigrationService.GetLocationById(this.oTrpconsignment.CN_LOC).subscribe(
          data2 => {
            this.FromLOC = data2.LOC_NAME;
          });
        this.oMasterConfigrationService.GetLocationById(this.oTrpconsignment.CN_TOLOC).subscribe(
          data2 => {
            this.TOLOC = data2.LOC_NAME;

          });
        if (this.oTrpconsignment.CN_FRT_MODE == "1") {
          this.FreightMode = "Paid";
        }
        else if (this.oTrpconsignment.CN_FRT_MODE == "2") {
          this.FreightMode = "To Pay (CNE)";
        }
        else if (this.oTrpconsignment.CN_FRT_MODE == "3") {
          this.FreightMode = "TBB (CNR)";
        }
        else if (this.oTrpconsignment.CN_FRT_MODE == "4") {
          this.FreightMode = "TBB (CNE)";
        }
        else if (this.oTrpconsignment.CN_FRT_MODE == "5") {
          this.FreightMode = "TBB (3P)";
        }
        else if (this.oTrpconsignment.CN_FRT_MODE == "6") {
          this.FreightMode = "To Pay (CNR)";
        }
        this.InvoiceList = [];
        this.oGRbookingervice.GETInvoiceBYGRNO(this.oTrpconsignment.CN_NO).subscribe(
          datainv => {
            if (datainv != null && datainv.length > 0)
              datainv.forEach(element => {
                let arr: any[] = [ {
                  CNINVOICE_ID: element.CN_INVOICE_ID, CNLOC: element.CN_LOC, CNNO: element.CN_NO,
                  CNINVNO: element.CN_INVNO, CNINVDATE: element.CN_INVDATE, CNINVVALUE: element.CN_INVVALUE,
                  CNNETVALUE: element.CN_NETVALUE, CNITMDESC: element.CN_ITMDESC, CNBOXTYPE: element.CN_BOXTYPE,
                  CNNOB: element.CN_NOB, CNPARTNO: element.CN_PARTNO, CNQTY: element.CN_QTY, CNH: element.CN_H,
                  CNL: element.CN_L, CNW: element.CN_W, CNCFT: element.CN_CFT, CNACTWT: element.CN_ACTWT, CNCHGWT: element.CN_CHGWT,
                  TS: element.TS, CNEWAYBILLNO: element.CN_EWAYBILLNO, CNEWAYEXPIRYDT: element.CN_EWAYEXPIRYDT, CNPARTNO2: element.CN_PARTNO2,
                  CNPARTNO3: element.CN_PARTNO3, CNPARTQTY1: element.CN_PARTQTY1, CNPARTQTY2: element.CN_PARTQTY2, CNPARTQTY3: element.CN_PARTQTY3,
                  CREATEDBYUSERID: element.CREATEDBY_USERID, UPDATEDBYUSERID: element.UPDATEDBY_USERID, CREATEDDATE: element.CREATED_DATE, UPDATEDDATE: element.UPDATED_DATE,
                  ISACTIVE: element.IS_ACTIVE
                } ];
                this.InvoiceList.push(arr[ 0 ]);
              });
          });
        this.oApplicationcl.IsProgressBarEnable = true;
        this.oVchalanervice.GETChallanList(4, 0, this.oTrpconsignment.CN_NO, 1).subscribe(
          data => {
            this.oApplicationcl.IsProgressBarEnable = false;
            this.ChallanList = [];
            this.ChallanList = data;
            if (this.oTrpconsignment.CN_RUNSTATUS.includes('In Transit') && this.ChallanList.length > 0) {
              let vhno: string = this.ChallanList[ 0 ].CH_VEHNO;
              this.oVchalanervice.GETGPSDATA(1, vhno).subscribe(
                data4 => {
                  this.oGpsdata = data4;
                  // console.log(this.oGpsdata);
                });
            }
          });

        this.oApplicationcl.IsProgressBarEnable = true;
        this.oGRbookingervice.GETGRUPDATEHISTORY(this.oTrpconsignment.CN_NO).subscribe(
          data => {
            this.oApplicationcl.IsProgressBarEnable = false;
            this.GrUpdateHistory = [];
            this.GrUpdateHistory = data;
          });
        this.oApplicationcl.IsProgressBarEnable = true;
        this.oAccountService.GETPAYMETAGAINSTGR(this.oTrpconsignment.CN_NO).subscribe(
          data => {
            this.oApplicationcl.IsProgressBarEnable = false;
            this.MRDetail = [];
            this.MRDetail = data;
          });


        this.oApplicationcl.IsProgressBarEnable = true;
        this.oGRbookingervice.GETBillDetailByGRNo(this.oTrpconsignment.CN_NO).subscribe(
          data => {
            this.oTrpmstbillDetail = data;
            this.oGRbookingervice.GETBILLDetail(this.oTrpmstbillDetail.BILL_NO).subscribe(
              data => {
                this.oTrpmstbill = data;
                this.oApplicationcl.IsProgressBarEnable = false;
              });
          });
      });
  }


  public Print() {
    if (isNullOrUndefined(this.oTrpconsignment.CN_NO)) {
      alert("Please enter GR no before print");
      return;
    }
    else {
      window.open(environment.MvcWebUrl + "ReportViewer.aspx?ReportType=ConsignmentPrint&FromCNNo=" + this.oTrpconsignment.CN_NO + "&ToCNNo=" + this.oTrpconsignment.CN_NO + "&PODCopy=y&CRCopy=n&CNCopy=n&Mail=n");
    }
  }

  public PodStatus(cnno: string) {
    this.oGRbookingervice.GETPODStatus(cnno).subscribe(
      data => {
        let oServiceStatus: ServiceStatus = data;
        if (oServiceStatus.Status == ResponseCode.NotExist.toString() || oServiceStatus.Status == ResponseCode.Exception.toString()) {
          alert(oServiceStatus.ErrorMessage);
        }
        else {
          window.open(environment.MvcWebUrl + "Podprint.aspx?id=" + oServiceStatus.ErrorMessage + ".jpg");
          //window.open("http://14.99.197.218/POD/" + oServiceStatus.ErrorMessage + ".jpg");
        }
      });
  }


  public Close() {

  }

  public UpdateDelivery() {
    this.oApplicationcl.IsProgressBarEnable = true;
    this.oGRbookingervice.UpdateDeliveryInterest(this.oTrpconsignment.CN_NO, this.oTrpconsignment.CN_DELI_INST, this.userId).subscribe(
      data => {
        this.oApplicationcl.IsProgressBarEnable = false;
        let oServiceStatus: ServiceStatus = data;
        if (oServiceStatus.Status == ResponseCode.SaveSuccessFully.toString()) {
          alert(oServiceStatus.ErrorMessage);
          document.getElementById('btnClose').click();
        }
        else {
          alert(oServiceStatus.ErrorMessage);
        }
      });
  }
}